import React from "react";
import PropTypes from "prop-types";
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import TransactionPendingForm from "./component/TransactionPendingForm";

class TransactionPendingPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Rastreabilidade"/>,
      <BreadcrumbItem key={2} title="Lista de Transações" to="/list/transactions"/>,
      <BreadcrumbItem key={3} title="Nova transação" to="#" active={true}/>];
    return (
        <Page title="Resolver transação pendente" breadcrumbs={breadcrumbs}>
          <TransactionPendingForm match={match} history={history}/>
        </Page>
    );
  }
}

TransactionPendingPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransactionPendingPage;


// WEBPACK FOOTER //
// ./src/transaction/TransactionPendingPage.js